import { render, staticRenderFns } from "./u-tit-icon.vue?vue&type=template&id=610aebfe&scoped=true&"
import script from "./u-tit-icon.vue?vue&type=script&lang=js&"
export * from "./u-tit-icon.vue?vue&type=script&lang=js&"
import style0 from "./u-tit-icon.vue?vue&type=style&index=0&id=610aebfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610aebfe",
  null
  
)

export default component.exports